// Chunk failures carry no app stack frame, so the runtime message is all there is
// to match on. Browser-global-free: sentry.shared-config.js loads it server-side.
const CHUNK_LOAD_PATTERN = /Failed to load chunk |Loading (?:CSS )?chunk \S+ failed/i;

export const isChunkLoadMessage = message =>
  typeof message === 'string' && CHUNK_LOAD_PATTERN.test(message);

const isChunkLoadError = error =>
  !!error &&
  (error.name === 'ChunkLoadError' || isChunkLoadMessage(error.message));

export default isChunkLoadError;
